const o="ads",a="patrocinado",t={[o]:a};export{o as ADS_PARAM_NAME,t as SPONSORED_ADS_SEARCH_PARAMS,a as SPONSORED_PARAM_VALUE};
